module.exports = __webpack_public_path__ + "img/number-grey.d80ebd54.svg";